import { Component, Input } from '@angular/core';
import { LightshowState } from '../lightshow-state';
import { LightShowSegment } from '../Segments/lightshow-segment';
import { LightShowService } from '../../../app/_services/light-show.service';

@Component({
  selector: 'app-preview',
  template: `
   <div
      class="preview center-items"
      [ngClass]="{'fullscreen-mode-active': fullscreenMode, 'fullscreen-flash' : fullscreenMode && state.isFlashOn}"
    >
      <div
          *ngIf="!fullscreenMode"
           style="background: black"
          class="flash center-items"
          [ngClass]="{'flashOn': false}"
          [ngStyle]="{'box-shadow': state.isFlashOn && state.playbackPosition > 50 ? '0 0 69px 64px rgba(255,255,255,'+state.brightness+')' : 'none'}"
          >
        <div
        [ngStyle]="{
          'box-shadow': state.isFlashOn && state.playbackPosition > 50 ? '0 0 18px 38px rgba(255,255,255,' + (state.brightness + 0.3) + ')' : 'none',
          'background': state.isFlashOn && state.playbackPosition > 50 ? 'rgba(255,255,255,' + (state.brightness + 0.3) + ')' : 'transparent'
        }"
        >
        </div>
      </div>

      <div
        *ngIf="!fullscreenMode"
        class="bracket"
        tooltip="Full screen"
        (click)="openFullscreenHandler()"
      >
       <div></div>
       <div></div>
       <div></div>
       <div></div>
      </div>

      <div class="icon-frame center">
       <div class="camera-flash"></div>
       <div class="camera center">
         <div class="camera-dot"></div>
       </div>
      </div>

      <div
        class="content"
        *ngIf="selectedImageSegment"
        style="z-index: 2"
        [ngStyle]="{ 'background' : imageFlashHandle(), 'background-color': !selectedColorSegment ? colorToDisplay : 'rgba(0,0,0,0)', 'opacity': imageSegmentOpacity}"
      >
      </div>

      <div
        class="content"
        *ngIf="selectedColorSegment"
        [ngStyle]="{'background': colorToDisplay, 'opacity': colorSegmentOpacity}"
      >
      </div>

    </div>
   `,
  styles: [`
   .fullscreen-mode-active {
     border: 15px solid #151515;
     border-radius: 30px;
     width: 100%;
     height: 100%;
   }

   .fullscreen-mode-active .content {
     border-radius: 6px;
     height: calc(100% - 30px);
     width: calc(100% - 30px);
   }

   .fullscreen-flash {
     border: 15px solid white;
   }

   .icon-frame {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2.5px white solid;
    position: relative;
    top: 30%;
    transform: scale(0.7);
  }

  .camera {
    background: white;
    border-radius: 16%;
    width: 23px;
    height: 17px;
    border: 0.7px solid black;
    z-index: 1;
  }

  .camera-flash {
    position: absolute;
    top: 27%;
    background: white;
    width: 10px;
    height: 3px;
    border: 0.3px solid rgb(34, 100, 140);
    border-radius: 25% 25% 0 0;
  }

  .camera-dot {
    border-radius: 50%;
    border: 0.5px solid rgb(34, 100, 140);
    background: rgb(245, 100, 90);
    height: 12px;
    width: 12px;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
  }
 `]
})

export class PreviewComponent {
  @Input()
  state: LightshowState;
  @Input()
  selectedColorSegment: LightShowSegment;
  @Input()
  selectedImageSegment: LightShowSegment;
  @Input()
  fullscreenMode = false;
  @Input()
  colorToDisplay: string;
  @Input()
  colorSegmentOpacity: number;
  @Input()
  imageSegmentOpacity: number;

  constructor(private lightShowService: LightShowService) { }

  imageFlashHandle() {
    return 'url(' + this.getImageUrl() + ')';
  }

  openFullscreenHandler() {
    this.lightShowService.openFullScreen$.next();
  }

  getImageUrl() {
    return this.selectedImageSegment.imageUrl['changingThisBreaksApplicationSecurity'] || this.selectedImageSegment.imageUrl;
  }
}
